/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const UserUpdateIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="UserUpdateIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M14.1211 9.87891C14.664 10.4218 15 11.1716 15 12C15 12.7695 14.7077 13.469 14.2314 14H15V15H12V14C13.1046 14 14 13.1046 14 12C14 11.4477 13.776 10.9479 13.4141 10.5859L14.1211 9.87891Z"
                fill="currentColor"
              />
              <path
                d="M12 9V10C10.8954 10 10 10.8954 10 12C10 12.5523 10.224 13.0521 10.5859 13.4141L9.87891 14.1211C9.33601 13.5782 9 12.8284 9 12C9 11.2305 9.29228 10.531 9.76855 10H9V9H12Z"
                fill="currentColor"
              />
              <path
                d="M7 10H3.5C2.67157 10 2 10.6716 2 11.5V13H1V11.5C1 10.1193 2.11929 9 3.5 9H7V10Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 2C8.65685 2 10 3.34315 10 5C10 6.65685 8.65685 8 7 8C5.34315 8 4 6.65685 4 5C4 3.34315 5.34315 2 7 2ZM7 3C5.89543 3 5 3.89543 5 5C5 6.10457 5.89543 7 7 7C8.10457 7 9 6.10457 9 5C9 3.89543 8.10457 3 7 3Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

UserUpdateIcon.tags = [
  'user',
  'refresh',
  'account',
  'change',
  'update',
  'profile',
];

UserUpdateIcon.category = 'General Icons';

UserUpdateIcon.iconSize = 16;
